import React from "react";

export default (Component, initiallyExpanded = false) => class Expandable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: initiallyExpanded
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle(e) {
    var { expanded } = this.state;
    if (e) {
      e.stopPropagation();
    }
    this.setState({ expanded: !expanded }); // eslint-disable-line react/no-set-state
  }

  render() {
    var { expanded } = this.state;
    return <Component {...this.props} expanded={expanded} toggle={this.toggle} />;
  }
};
